<div class="vocabulary-container tab-content">
    <div *ngIf="useOldStyleUI" class="card-column">

        <div *ngIf="vocabularyEntries" class="card-deck">

            <div *ngFor="let vocabularyEntry of vocabularyEntries; let idx = index" class="card-block">
                <vocabulary-editor-detail *ngIf="!vocabularyEntry.isEditable"
                                          [idx]="idx"
                                          (replaceRequest)="replaceVocabularyEntry($event)"
                                          (deleteRequest)="deleteVocabularyEntry($event)"
                                          [vocabularyInfo]="vocabularyEntry"
                                          [saveInProgress]="saveInProgress"
                                          [selectedWord]="selectedWord"
                >
                </vocabulary-editor-detail>
                <vocabulary-editor-multidetail *ngIf="vocabularyEntry.isEditable"
                                               [idx]="idx"
                                               (updateRequest)="updateEditableEntry($event)"
                                               (cancelRequest)="cancelVocabularyEntry($event)"
                                               (searchRequest)="doSearch($event)"
                                               [vocabularyInfo]="vocabularyEntry"
                                               [saveInProgress]="saveInProgress"
                                               [selectedWord]="selectedWord"
                >
                </vocabulary-editor-multidetail>
            </div>


            <div *ngIf="newVocabularyEntry.isEditable" class="card-block">
                <vocabulary-editor-multidetail [idx]="newVocabularyEntry"
                                               (updateRequest)="updateEditableEntry($event)"
                                               (cancelRequest)="cancelVocabularyEntry($event)"
                                               (searchRequest)="doSearch($event)"
                                               [vocabularyInfo]="newVocabularyEntry"
                                               [saveInProgress]="saveInProgress"
                                               [selectedWord]="selectedWord"
                >
                </vocabulary-editor-multidetail>
            </div>
        </div>
    </div>

    <div *ngIf="!useOldStyleUI" class="card col-md-12">


        <div *ngFor="let vocabularyEntry of vocabularyEntries" class="card-deck">
                <br/>
                <label class="form-check-label" for="isSelected">
                    <input class="form-check-input" id="isSelected" type="checkbox"
                           [checked]="vocabularyEntry._isSelected"
                           [(ngModel)]="vocabularyEntry._isSelected"> {{vocabularyEntry.word}} </label>
        </div>

    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="btn-group">
                <button class="btn btn-success" (click)="saveSelection()">Save All</button>
            </div>
        </div>
    </div>
</div>
